import { render } from "./ProductOverviewBuyers.vue?vue&type=template&id=b76b9d70&scoped=true"
import script from "./ProductOverviewBuyers.vue?vue&type=script&lang=js"
export * from "./ProductOverviewBuyers.vue?vue&type=script&lang=js"

import "./ProductOverviewBuyers.vue?vue&type=style&index=0&id=b76b9d70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b76b9d70"]])

export default __exports__